import React from "react"
import { Jumbotron } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel'


import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import 'bootstrap/dist/css/bootstrap.css';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
  <Carousel>
  <Carousel.Item>
  <Jumbotron>
    <p><b>Hallo allemaal!</b><br /><br />
      Ik ben Eline Bouwman, 14 jaar oud en woon in Zwolle. 
      Over 1,5 jaar wil ik graag mee met een grote educatieve zeilreis van de Wylde Swan, van Sint Maarten naar Cuba.
      Deze reis kost veel geld en daarom verkoop ik mijn zelfgemaakte mondkapjes. 
      De mondkapjes zijn van katoen, op 60 graden uitwasbaar en in verschillende kleuren en printjes te bestellen.  
      Ik maak de mondkapjes in de maten S/M/L en verkoop ze voor 5 EURO per stuk exclusief verzendkosten. 
      Wil je ook graag dat ik deze reis kan maken, heb je nog een mondkapje nodig, dan kun je me sponseren door 
      een of meerdere mondkapjes te bestellen.
      Al veel tevreden klanten gingen je voor.....
      <br /><br />
      Reuze dank voor je bestelling!
     <br />
    </p>
    </Jumbotron>

  </Carousel.Item>

  <Carousel.Item>
     <Jumbotron>
       <h4>Voorbeeld model 1</h4>
       <center>
        <Image width="400px" height="400px" imageName="model1" /> <Image width="400px" height="400px" imageName="model1_open" /> 
        </center>
    </Jumbotron>

    </Carousel.Item> 

    <Carousel.Item>
     <Jumbotron>
       <h4> Voorbeeld model 7</h4>
       <center>
        <Image width="400px" height="400px" imageName="model8" /> <Image width="400px" height="400px" imageName="model8_open" /> 
        </center>
    </Jumbotron>
  </Carousel.Item>  

  <Carousel.Item>
     <Jumbotron>
       <h4>Reisboot</h4>
        <p>Dit is de boot waarmee ik de reis hoop te maken.</p>
        <Image type="fluid" imageName="boot" />
    </Jumbotron>
  </Carousel.Item>  
</Carousel>

  </Layout>
)

export default IndexPage
